import Cookies from 'js-cookie';
const state = {
    user: JSON.parse(Cookies.get('user') || null), // 存储用户数据
};

const mutations = {
    setUser(state, user) {
        state.user = user;
    },
    clearUser(state) {
        state.user = null;
    },
};

const actions = {
    setUser({ commit }, user) {
        commit('setUser', user);
        const userJson = JSON.stringify(user)
        if (userJson) {
            Cookies.set('user', userJson);
        }
    },
    clearUser({ commit }) {
        commit('clearUser');
        Cookies.remove('user');
    },
};

const getters = {
    isAuthenticated(state) {
        return !!state.user;
    },
    getUser(state) {
        return state.user;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};